import DOMPurify from "dompurify";
import { FC } from "react";
import { Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface NotificationBodyProps {
  body: string;
}

export const NotificationBody: FC<NotificationBodyProps> = ({ body }) => {
  const sanitizedHtml = DOMPurify.sanitize(body);

  return (
    <Typography
      sx={{
        ...nawyTheme.nawy.typography.english.variants.body.sm.regular,
        color: nawyTheme.nawy.colors.semantic.text.secondary,
        "& strong": {
          ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
          color: nawyTheme.nawy.colors.semantic.text.primary,
        },
      }}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};
